"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAeColors = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const availableColors = [
    '0',
    '1',
    '1S',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '22',
    '23',
    '24',
    '25',
    '26',
    '31',
    '32',
    '52',
    '72',
    '81',
    '82',
    '83',
];
const colors = {
    [echain_shared_igus_fundamentals_1.AppName.EIQ]: availableColors,
    // EKE it's not allowed to change the colors for AE's
    [echain_shared_igus_fundamentals_1.AppName.EKE]: [],
    // EIC, ECF has no ae's
    [echain_shared_igus_fundamentals_1.AppName.EIC]: [],
    [echain_shared_igus_fundamentals_1.AppName.ECF]: [],
    [echain_shared_igus_fundamentals_1.AppName.TEST]: [],
};
const getAeColors = (appName) => {
    return (0, echain_shared_ts_utils_1.clonePrimitive)(colors[appName]);
};
exports.getAeColors = getAeColors;
//# sourceMappingURL=aeColors.js.map